import { w as writable } from "./index2.js";
import { u as user } from "./auth.js";
import "./api.js";
const currentCustomer = writable(typeof window !== "undefined" ? sessionStorage.currentCustomer : null);
const availableAssociates = writable(typeof window !== "undefined" ? sessionStorage.availableAssociates : null);
const userCustomer = writable(typeof window !== "undefined" ? sessionStorage.userCustomer : null);
const userAsAssociate = writable(typeof window !== "undefined" ? sessionStorage.userAsAssociate : null);
user.subscribe((val) => {
  if (val && typeof val.associations !== "undefined") {
    userAsAssociate.set(val.associations[0]);
  }
});
export {
  availableAssociates as a,
  currentCustomer as c,
  userCustomer as u
};
//# sourceMappingURL=customer.js.map
